
import { Pipe, PipeTransform } from '@angular/core';
import { divisionsControlPanel } from '../../const/options';
import { isBuyerOfGrassiGroup, isSellerOfGrassiGroup } from '@shared-logic/subjects';
import { orderStatusConst, Order } from '@shared-logic/orders';

@Pipe({
    name: 'filterByDivisionControlPanel',
})
export class FilterByDivisionControlPanelPipe implements PipeTransform {
    transform(orderList: Order[], divisionSelected: string, statusSelected?: number) {
        if (!orderList || !divisionSelected) return orderList;

        return orderList.filter((order) => isFromDivision(order, divisionSelected, statusSelected));
    }
}

export function isFromDivision(order: Order, divisionSelected: string, statusSelected?: number) {
    const isBuyerGrassi = isBuyerOfGrassiGroup(order.price.observations.buyer);
    const isSellerGrassi = isSellerOfGrassiGroup(order.sellerData.codeS);
    const isDraft = statusSelected == orderStatusConst.AUTORIZATION;

    switch (divisionSelected) {
        case divisionsControlPanel.BUY_COMMODITIES:
            // Compras del Grupo: comprador del grupo y vendedor fuera del grupo.
            // Excepcion: en borrador (status 7), tambien se muestran intragrupo.
            return isBuyerGrassi && (!isSellerGrassi || isDraft);

        case divisionsControlPanel.SELL_COMMODITIES:
            // Ventas del Grupo: vendedor del grupo y comprador fuera del grupo.
            return isSellerGrassi && !isBuyerGrassi;

        case divisionsControlPanel.INTRA_GROUP:
            // Intragrupo: comprador y vendedor pertenecen al grupo.
            return isBuyerGrassi && isSellerGrassi;

        case divisionsControlPanel.EXPORTS:
            // Exportadores: ni comprador ni vendedor pertenecen al grupo.
            return !isBuyerGrassi && !isSellerGrassi;

        default:
            return true;
    }
}
